export const DOWNLOAD_CASTS_INVALIDATE = "DOWNLOAD_CASTS_INVALIDATE";
export const DOWNLOAD_CASTS_FETCH_REQUEST = "DOWNLOAD_CASTS_FETCH_REQUEST";
export const DOWNLOAD_CASTS_FETCH_SUCCESS = "DOWNLOAD_CASTS_FETCH_SUCCESS";
export const DOWNLOAD_CASTS_FETCH_ERROR = "DOWNLOAD_CASTS_FETCH_ERROR";
export const DOWNLOAD_CASTS_CHANGE_SELECTED = "DOWNLOAD_CASTS_CHANGE_SELECTED";
export const DOWNLOAD_FILE_FETCH_CONTENT_REQUEST =
  "DOWNLOAD_FILE_FETCH_CONTENT_REQUEST";
export const DOWNLOAD_FILE_FETCH_CONTENT_SUCCESS =
  "DOWNLOAD_FILE_FETCH_CONTENT_SUCCESS";
export const DOWNLOAD_FILE_FETCH_CONTENT_ERROR =
  "DOWNLOAD_FILE_FETCH_CONTENT_ERROR";
export const DOWNLOAD_PROCESS_PDF_FILE_FETCH_CONTENT_REQUEST =
  "DOWNLOAD_PROCESS_PDF_FILE_FETCH_CONTENT_REQUEST";
export const DOWNLOAD_PROCESS_PDF_FILE_FETCH_CONTENT_SUCCESS =
  "DOWNLOAD_PROCESS_PDF_FILE_FETCH_CONTENT_SUCCESS";
export const DOWNLOAD_CASTS_SET_PAGE_NUMBER = "DOWNLOAD_CASTS_SET_PAGE_NUMBER";
export const DOWNLOAD_CASTS_SET_ITEMS_PER_PAGE =
  "DOWNLOAD_CASTS_SET_ITEMS_PER_PAGE";
export const DOWNLOAD_DEVICE_INFO_REQUEST = "DOWNLOAD_DEVICE_INFO_REQUEST";
export const DOWNLOAD_DEVICE_INFO_SUCCESS = "DOWNLOAD_DEVICE_INFO_SUCCESS";
export const DOWNLOAD_DEVICE_INFO_ERROR = "DOWNLOAD_DEVICE_INFO_ERROR";
export const SET_PROCESSING_STAGE_FILTER = "SET_PROCESSING_STAGE_FILTER";
export const SET_INSTRUMENT_FILTER = "SET_INSTRUMENT_FILTER";
export const SET_INSTRUMENT_FILTER_OVERRIDE = "SET_INSTRUMENT_FILTER_OVERRIDE";
export const SET_SERIAL_NUM_FILTER = "SET_SERIAL_NUM_FILTER";
export const SET_WORKAREA_FILTER = "SET_WORKAREA_FILTER";
export const SET_ORGANIZATION_FILTER = "SET_ORGANIZATION_FILTER";
export const SET_BUFFER_FILTER = "SET_BUFFER_FILTER";
export const SET_UPCAST_FILTER = "SET_UPCAST_FILTER";
export const SET_SURVEY_FILTER = "SET_SURVEY_FILTER";
export const SET_STATION_FILTER = "SET_STATION_FILTER";
export const SET_FILENAME_FILTER = "SET_FILENAME_FILTER";
export const SET_CAST_PK_FILTER = "SET_CAST_PK_FILTER";
export const SET_HAKAI_ID_FILTER = "SET_HAKAI_ID_FILTER";
export const SET_SURVEY_STATION_OPTIONS = "SET_SURVEY_STATION_OPTIONS";
export const SET_SURVEY_STATION_OPTIONS_FETCH =
  "SET_SURVEY_STATION_OPTIONS_FETCH";
export const SET_START_DATE_FILTER = "SET_START_DATE_FILTER";
export const SET_END_DATE_FILTER = "SET_END_DATE_FILTER";
export const SET_TOTAL_CASTS_WITH_FILTERS = "SET_TOTAL_CASTS_WITH_FILTERS";
export const SET_TOTAL_CASTS_WITH_FILTERS_ERROR =
  "SET_TOTAL_CASTS_WITH_FILTERS_ERROR";
export const SET_CTD_DOWNLOAD_TYPE = "SET_CTD_DOWNLOAD_TYPE";
export const ZIP_DOWNLOAD_FETCH_REQUEST = "ZIP_DOWNLOAD_FETCH_REQUEST";
export const ZIP_DOWNLOAD_FETCH_SUCCESS = "ZIP_DOWNLOAD_FETCH_SUCCESS";
export const ZIP_DOWNLOAD_FETCH_ERROR = "ZIP_DOWNLOAD_FETCH_ERROR";
export const XLSX_DOWNLOAD_FETCH_REQUEST = "XLSX_DOWNLOAD_FETCH_REQUEST";
export const XLSX_DOWNLOAD_FETCH_SUCCESS = "XLSX_DOWNLOAD_FETCH_SUCCESS";
export const XLSX_DOWNLOAD_FETCH_ERROR = "XLSX_DOWNLOAD_FETCH_ERROR";
export const CSV_DOWNLOAD_FETCH_REQUEST = "CSV_DOWNLOAD_FETCH_REQUEST";
export const CSV_DOWNLOAD_FETCH_SUCCESS = "CSV_DOWNLOAD_FETCH_SUCCESS";
export const CSV_DOWNLOAD_FETCH_ERROR = "CSV_DOWNLOAD_FETCH_ERROR";
export const XLSX_DOWNLOAD_METADATA_FETCH_REQUEST =
  "XLSX_DOWNLOAD_METADATA_FETCH_REQUEST";
export const XLSX_DOWNLOAD_METADATA_FETCH_SUCCESS =
  "XLSX_DOWNLOAD_METADATA_FETCH_SUCCESS";
export const XLSX_DOWNLOAD_METADATA_FETCH_ERROR =
  "XLSX_DOWNLOAD_METADATA_FETCH_ERROR";
export const CSV_DOWNLOAD_METADATA_FETCH_REQUEST =
  "CSV_DOWNLOAD_METADATA_FETCH_REQUEST";
export const CSV_DOWNLOAD_METADATA_FETCH_SUCCESS =
  "CSV_DOWNLOAD_METADATA_FETCH_SUCCESS";
export const CSV_DOWNLOAD_METADATA_FETCH_ERROR =
  "CSV_DOWNLOAD_METADATA_FETCH_ERROR";
export const FAQ_MODAL_OPEN = "FAQ_MODAL_OPEN";
export const FAQ_MODAL_CLOSE = "FAQ_MODAL_CLOSE";
export const CAST_DIST_CHART_MODAL_OPEN = "CAST_DIST_CHART_MODAL_OPEN";
export const CAST_DIST_CHART_MODAL_CLOSE = "CAST_DIST_CHART_MODAL_CLOSE";
export const SET_BRUSH_EXTENT = "SET_BRUSH_EXTENT";
export const CLEAR_BRUSH = "CLEAR_BRUSH";
export const BRUSH_DID_CLEAR = "BRUSH_DID_CLEAR";
export const CAST_DIST_CHART_DATA_FETCH_REQUEST =
  "CAST_DIST_CHART_DATA_FETCH_REQUEST";
export const CAST_DIST_CHART_DATA_FETCH_SUCCESS =
  "CAST_DIST_CHART_DATA_FETCH_SUCCESS";
export const CAST_DIST_CHART_DATA_FETCH_ERROR =
  "CAST_DIST_CHART_DATA_FETCH_ERROR";
export const PREVIEW_FILE_DIALOG_OPEN = "PREVIEW_FILE_DIALOG_OPEN";
export const PREVIEW_FILE_DIALOG_CLOSE = "PREVIEW_FILE_DIALOG_CLOSE";
export const PREVIEW_FILE_SET_TITLE = "PREVIEW_FILE_SET_TITLE";
export const PREVIEW_FILE_SET_BODY = "PREVIEW_FILE_SET_BODY";
export const BULK_UPDATE_DOWNLOAD_FILTERS = "BULK_UPDATE_DOWNLOAD_FILTERS";
export const SIGN_OUT_COMPLETE = "SIGN_OUT_COMPLETE";
export { WORKAREA_SET } from "features/workarea/constants";

// Process levels served from the "data" (QC'd) views rather than raw_data.
export const DATA_PROCESS_LEVELS = [
  "8_binAvg",
  "9_qc_auto",
  "10_qc_pi",
  "11_qc_pi_research"
];
